export type CompletionStatusType = "notStarted" | "inProgress" | "completedMinimal" | "completedFull";

export interface DataItemCompletionStatus {
  [key: string]: CompletionStatusType;
}

export type DataVerificationTooltipKey =
  | "dataVerification.veryGoodTooltip"
  | "dataVerification.sufficientTooltip"
  | "dataVerification.insufficientTooltip"
  | "dataVerification.optionalTooltip";

export enum DataGroupEnum {
  generalInfo = "generalInfo",
  plotData = "plotData",
  buildingData = "buildingData",
  energyAndPhotovoltaic = "energyAndPhotovoltaic",
  buildingStandard = "buildingStandard",
  modernization = "modernization",
  financialAndRentalInfo = "financialAndRentalInfo",
  propertyImages = "propertyImages",
}

export type DataGroupType = `${DataGroupEnum}`;

export const DATA_GROUPS = Object.values(DataGroupEnum);
